import { render, staticRenderFns } from "./leadSvg.vue?vue&type=template&id=d58e6ebc"
import script from "./leadSvg.vue?vue&type=script&lang=js"
export * from "./leadSvg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports